module.exports = __webpack_public_path__ + "img/1.a3618f8a.png";